<div *ngIf="snackType; else oldView">
  <div class="snack-container">
    <div class="snack-icon-message">
      <div class="snack-icon">
        <img [src]="toastIconImage">
      </div>
      <div class="snack-message">
        <span>{{data.message}}</span>
      </div>
    </div>
    <div class="snack-close-button">
      <mat-icon (click)="onCloseClick()">close</mat-icon>
    </div>
  </div>
</div>
<!-- TODO: remover template abaixo e ngIf acima depois de atualizar as chamadas do CustomSnackbarService -->
<ng-template #oldView>
  <div class="container">
    <div class="icon">
      <span class="material-icons">
        done
      </span>
    </div>
    <div class="message">
      {{ data.message }}
    </div>
  </div>
</ng-template>
